// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1880":"1ed56286","4585":"f05fa6fc","5008":"f05fa6fc","9450":"f05fa6fc","9755":"f05fa6fc"}[chunkId] + ".chunk.css";
};